// 通用色 / 同系色 / 色名 —— 编辑/新建分类（panels.jsx）+ xlsx 图例（io/xlsx）共用的单一数据源。
// 改色名/调色板只改这里，两处自动同步。

export const GENERIC_PALETTE = [
  '#B49EE0',  // 紫（睡眠 / --c-sleep）
  '#6090CC',  // 深蓝（预备 / --c-prep）
  '#E8588C',  // 玫红（运动 / --c-exer）
  '#B6D880',  // 绿（专注 / --c-focus）
  '#F7D560',  // 蛋黄（吃 / --c-fun1）
  '#F2A04D',  // 橙（娱乐 / --c-fun）
  '#F0D5BC',  // 桦木（亲友 / --c-soc）
];
export const GENERIC_PALETTE_NAMES = ['紫', '深蓝', '玫红', '绿', '蛋黄', '橙', '桦木'];
export const FAMILY_PALETTE_NAMES = {
  sleep:    ['浅紫', '淡紫', '紫红', '嫣红', '深紫', '深玫红', '浅葡萄酒'],
  prep:     ['天蓝', '浅青', '牛仔蓝', '深蓝', '青', '深青', '深孔雀'],
  exercise: ['浅粉', '浅珊瑚', '樱花粉', '珊瑚红', '深玫红', '正大红', '西瓜红'],
  focus:    ['浅嫩绿', '浅青绿', '草绿', '青绿', '深绿', '深青', '深青蓝'],
  fun:      ['明黄', '香槟金', '蛋黄', '橙', '焦糖', '浅棕', '大便棕'],
  social:   ['浅米', '土豪金', '浅木', '木', '深木', '栗', '茶色'],
};
export const FAMILY_PALETTES = {
  sleep:    ['#F5EBFA', '#DBC9F0', '#BD8AC9', '#E573A0', '#A58EE0', '#D9709F', '#A4456C'],
  prep:     ['#C5E2F0', '#A8E0DE', '#82B0DB', '#6090CC', '#4DBDB5', '#4FA8AE', '#4A7878'],
  exercise: ['#FCD8E0', '#FFCDC7', '#FFB5C5', '#E66B6B', '#C2487B', '#DC143C', '#E14570'],
  focus:    ['#D4E8AB', '#D2EDE8', '#99C560', '#58B7AA', '#82B560', '#58A8AC', '#4A8585'],
  fun:      ['#FFE066', '#EBD9A5', '#F7D560', '#F2A04D', '#DAA050', '#BD9778', '#A0794D'],
  social:   ['#F8E5D2', '#D4AF37', '#D9B89B', '#D3AC8F', '#C19A78', '#A88665', '#6B4423'],
};

// hex（6 位，可带/不带 #）→ 系统里的色名（同系色优先，通用色兜底）。无匹配返回 ''。
const _norm = (hex) => (hex ? String(hex).replace('#', '').toUpperCase() : '');
const _HEX_TO_NAME = {};
Object.keys(FAMILY_PALETTES).forEach(fam => {
  (FAMILY_PALETTES[fam] || []).forEach((hex, i) => {
    const k = _norm(hex), name = (FAMILY_PALETTE_NAMES[fam] || [])[i];
    if (k && name && !_HEX_TO_NAME[k]) _HEX_TO_NAME[k] = name;
  });
});
GENERIC_PALETTE.forEach((hex, i) => {
  const k = _norm(hex);
  if (k && !_HEX_TO_NAME[k]) _HEX_TO_NAME[k] = GENERIC_PALETTE_NAMES[i];
});
// 分类专属色名补充：家族/通用调色板里没有、但分类在用的色（覆盖优先）。hex 不带 #、大写。
const EXTRA_COLOR_NAMES = {
  'F2B26A': '蟹黄', // 书影音 --c-fun3
};
Object.entries(EXTRA_COLOR_NAMES).forEach(([k, name]) => { _HEX_TO_NAME[k] = name; });
export function colorNameForHex(hex) {
  return _HEX_TO_NAME[_norm(hex)] || '';
}
